import { Form, FormItemProps } from 'antd'
import { ReactElement } from 'react'

import { FieldLabel } from './FieldLabel'
import { ReadOnlyControl, useIsReadOnlyForm } from './ReadOnly'

type Props = Omit<FormItemProps, 'label' | 'name' | 'children'> & {
  name: (string | number)[]
  /** Form number of the field, e.g. "25.11". */
  number?: string
  label: string
  children: ReactElement
}

/**
 * A field of Form 058-1/e: its label carries the form number and, when the field was prefilled,
 * where the value came from. The prefill source path is the field path without the `form` root.
 * In a read-only fișa the value is shown as text instead of the input.
 */
export const HivFormItem = ({
  name,
  number,
  label,
  children,
  ...props
}: Props) => {
  const isReadOnly = useIsReadOnlyForm()
  const field = name.filter((part) => part !== 'form').join('.')

  return (
    <Form.Item
      name={name}
      label={<FieldLabel number={number} label={label} field={field} />}
      {...props}
    >
      {isReadOnly ? <ReadOnlyControl>{children}</ReadOnlyControl> : children}
    </Form.Item>
  )
}
